import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'component/Navbars/DashboardNavbar';

import DataTable from 'component/Tables/DataTable';

import { useOrders } from 'api/getOrders';
import { PaidBadge, PendingBadge } from './components/Badge';
import { Tooltip } from '@mui/material';
import ArgonButton from 'component/Argon/ArgonButton';
import mongoIdToDt from 'utils/mongoIdToDt';

function Orders() {
  const navigate = useNavigate();
  const { data: rows } = useOrders();

  return (
    <DashboardLayout bgColor="success">
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <ArgonBox>
              <Card>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
                  <ArgonBox lineHeight={1}>
                    <ArgonTypography variant="h5" fontWeight="medium">
                      รายการสั่งซื้อ
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>

                <ArgonBox px={3}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: 'วัน/เวลา',
                          Cell: ({ row }) => mongoIdToDt(row.original._id),
                        },
                        {
                          Header: 'เลขที่',
                          Cell: ({ row }) => <TdNo row={row} />,
                          accessor: 'invoiceId',
                        },
                        { Header: 'จำนวนกรมธรรม์', accessor: 'total' },
                        { Header: 'จำนวนเงิน', accessor: 'amount' },
                        {
                          Header: 'การชำระ',
                          accessor: 'isPaid',
                          Cell: ({ value }) => (value ? PaidBadge : PendingBadge),
                        },
                        {
                          Header: 'เมนู',
                          Cell: ({ row }) => <TdMenu row={row} navigate={navigate} />,
                        },
                      ],
                      rows,
                    }}
                    entriesPerPage={{
                      defaultValue: 10,
                      entries: [5, 10, 25, 50, 100],
                    }}
                    canSearch
                  />
                </ArgonBox>
              </Card>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </DashboardLayout>
  );
}

export default Orders;

function TdNo({ row }) {
  const value = row.original;
  // if (value?.isPaid) {
  // }
  return <Link to={`/order/${value.invoiceId}`}>{value.invoiceId}</Link>;
  // return <Link to={`/order/payment/${value.invoiceId}`}>{value.invoiceId}</Link>;
}

function TdMenu({ row, navigate }) {
  const value = row.original;
  function handleClick() {
    if (value?.isPaid) {
      navigate('/order/' + value.invoiceId);
    } else {
      navigate('/order/payment/' + value.invoiceId);
    }
  }
  return (
    <ArgonBox display="flex" alignItems="center">
      <ArgonBox ml={2} onClick={handleClick}>
        <Tooltip title="ต่อไป" placement="left">
          <ArgonButton variant="outlined" color="success" size="small" iconOnly circular>
            <Icon sx={{ fontWeight: 'bold' }}>navigate_next</Icon>
          </ArgonButton>
        </Tooltip>
      </ArgonBox>
    </ArgonBox>
  );
}
